<template>
  <div class="rj-content">
    <v-overlay :value="loader" z-index="7">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <h1 v-if="changeTitle === false">Mis consultas</h1>
    <h1 v-if="changeTitle">Pagos parciales</h1>
    <p class="main-description">
      Agenda una consulta conmigo y analizaremos tu carta astral durante una sesión
      presencial o virtual, en la que te ayudaré a definir las acciones futuras adecuadas
      para alcanzar el éxito.
    </p>

    <v-row v-if="payConsultation === false && queryData === false">
      <v-col>
        <v-card>
          <v-simple-table class="table-ctn">
            <template>
              <thead>
                <tr>
                  <th class="">Última cita</th>
                  <th class="">Motivo</th>
                  <th class="">Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="data in post" :key="data.id">
                  <td>{{ data.date }}</td>
                  <td>{{ data.reason }}</td>
                  <td
                    v-if="data.state.description === 'Pendiente de confirmación'"
                    class="text-left"
                  >
                    <span class="highlight">{{ data.state.description }}</span>
                  </td>
                  <td
                    v-if="data.state.description === 'Pendiente de pago'"
                    class="text-left"
                  >
                    <v-btn @click="pushPayConsultation(data.id)" class="primary"
                      >Pagar</v-btn
                    >
                  </td>
                  <td
                    v-if="
                      data.state.description === 'Confirmado' ||
                      data.state.description === 'Realizado' ||
                      data.state.description === 'Cancelado'
                    "
                    class="text-left"
                  >
                    {{ data.state.description }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
        <v-btn
          v-if="buttonNewConsult === false"
          class="primary mt-5"
          large
          @click="(dialogConfirmed = true), (consultConfirmed = true)"
          >Nueva consulta
        </v-btn>
        <v-btn
          v-if="buttonNewConsult === true"
          class="primary mt-5"
          small
          @click="(dialogConfirmed = true), (consultConfirmed = true)"
          >Nueva consulta
        </v-btn>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-dialog
        v-if="consultConfirmed"
        v-model="dialogConfirmed"
        max-width="512"
        class=""
      >
        <v-card rounded class="dialog-appointment pa-3">
          <v-icon
            @click="dialogConfirmed = false"
            style="position: absolute"
            class="close-btn"
            >mdi-close</v-icon
          >
          <div class="ctn-img text-center mt-8">
            <img src="../assets/logo.png" />
          </div>
          <v-card-text class="pb-0 mb-0">
            <p class="text-center modal-text pb-0 mb-0">
              La consulta se realiza por Skype, a continuación llena tus datos, luego te
              enviaremos un correo con los detalles de tu cita
            </p>
          </v-card-text>
          <v-card-actions id="modal-es">
            <v-btn color="primary" class="btn-continue" @click="redirectNewConsult"
              >Continuar</v-btn
            >
            <button
              color=""
              class="btn-continue"
              id="modal-en"
              @click="dialogConfirmed = false"
            >
              Cancelar
            </button>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-card class="ctn-new-query" v-if="payConsultation && queryData === false">
      <dt>Fecha de consulta</dt>
      <dl>{{ arrayPost.date }}</dl>

      <dt>Motivo de consulta</dt>
      <dl>
        {{ arrayPost.reason }}
      </dl>

      <dt>Costo de consulta</dt>
      <dl>US${{ arrayPost.price }}</dl>

      <dt v-if="paymentsTable === true && changeTitle === false">Últimos pagos</dt>
      <dt v-if="paymentsTable === true && changeTitle">Pagos parciales a la fecha</dt>
      <dl v-if="paymentsTable === true">
        <v-simple-table class="last-payments">
          <template>
            <thead>
              <tr>
                <th class="">Fecha y hora</th>
                <th class="">Monto</th>
                <th class="">Medio de pago</th>
                <th class="">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="dataPayment in postPayments" :key="dataPayment.id">
                <td>
                  {{ dataPayment.created_at.slice(0, 10) }}
                  {{ dataPayment.created_at.slice(11, 16) }}
                </td>
                <td>US$ {{ dataPayment.amount }}</td>
                <td v-if="dataPayment.payment_method_id === 2">
                  Tarjeta de crédito/débito
                </td>
                <td v-if="dataPayment.payment_method_id === 1">
                  Transferencia o Depósito
                </td>
                <td v-if="dataPayment.rejected === 0 && dataPayment.confirmed === 0">
                  Pendiente de confirmación
                </td>
                <td v-if="dataPayment.rejected === 1">Rechazado</td>
                <td v-if="dataPayment.confirmed === 1 && dataPayment.rejected !== 1">
                  Confirmado
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </dl>

      <dt v-if="paymentsTable === true">Pendiente de pago</dt>
      <dl v-if="paymentsTable === true">
        US$ {{ needToPay }}
        <strong v-if="confirmationPayment === true">
          -
          <strong class="primary-text" v-if="confirmationPayment === true">{{
            textConfirmation
          }}</strong></strong
        >
      </dl>

      <form>
        <!--<dt v-if="changeTitle" class="new-consult-title-line">-->
        <dt class="new-consult-title-line" v-if="changeTitle">
          <h2 style="font-family: 'Virgula Vulgaris'" class="mb-3">Nuevo pago</h2>
          <hr />
        </dt>
        <!-- <dt>Modo de pago</dt>
        <dl class="mb-0">
          <v-radio-group @change="otherMode" v-model="radiosMode" class="w100 radio-group">
            <v-radio class="radio-ctn" label="Pago total" value="2"></v-radio>
            &lt;!&ndash;<v-radio class="radio-ctn" label="Pago parcial" value="1"></v-radio>&ndash;&gt;
          </v-radio-group>
        </dl>-->
        <dl v-if="mode">
          <v-row>
            <v-col cols="6"></v-col>
            <v-col cols="6" class="pt-0 mt-0 mb-0 pb-0">
              <v-text-field
                type="text"
                onKeypress="if (event.keyCode < 45 || event.keyCode > 57) event.returnValue = false;"
                placeholder="US$xxx"
                v-model="partial"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </dl>

        <dt>Medio de pago</dt>
        <dl class="">
          <v-radio-group
            @change="otherMedium"
            v-model="radiosTransfer"
            class="w100 radio-group"
          >
            <!-- <v-radio class="radio-ctn" label="Tarjeta de crédito/débito" value="2"></v-radio> -->
            <v-radio
              class="radio-ctn"
              label="Transferencia o Depósito"
              value="1"
            ></v-radio>
            <v-radio class="radio-ctn" label="Paypal" value="3"></v-radio>
          </v-radio-group>
        </dl>

        <dl v-if="transfer">
          <dt>SI ESTÁS EN PERÚ:</dt>
        </dl>
        <dd v-if="transfer" class="description-transfer">
          ASTRO VISIÓN MUNDO SAC
          <br />
          RUC: 20605948317
          <br />
          BANCO DE CRÉDITO DEL PERÚ
          <br />
          <br />

          PAGOS EN SOLES
          <br />
          - Número de Cuenta: 194-99720088-0-59
          <br />
          - CCI: 00219419972008805995
          <br />
          <br />

          PAGO EN DÓLARES
          <br />
          - Número de Cuenta: 194-99720095-1-66
          <br />
          - CCI: 00219419972009516699
          <br />
          <br />
        </dd>
        <dl v-if="transfer">
          <dt>SI ESTÁS EN EE.UU:</dt>
        </dl>
        <dd v-if="transfer" class="description-transfer">
          ASTRO VISION INC.
          <br />
          CHASE BANK
          <br />
          PAGO EN DÓLARES
          <br />
          - Número de Cuenta: 112155616
          <br />
          - Número de routing: 267084131
          <br />
          - SWIFT: CHASUS33
          <br />
          - ABA: 021000021
          <br />
          - Zelle: raja@astrovision.us / +1 305 300 5473
          <br />
          <br />
        </dd>
        <dl v-if="transfer">
          <dt>SI ESTÁS EN ESPAÑA:</dt>
        </dl>
        <dd v-if="transfer" class="description-transfer">
          NORA RAQUEL PORTAL LA MADRID
          <br />
          BANCO CAIXA
          <br />
          - IBAN: ES93 2100 0997 6507 0005 8306
          <br />
          - BIC/CODIGO SWIFT: CAIXESBBXXX
          <br />
          <br />
        </dd>

        <!-- <dl v-if="transfer">
          <dt>OTROS:</dt>
        </dl>
        <dd v-if="transfer" class="description-transfer">
          WESTERN UNION o MONEY GRAM
          <br>
          - Nombre de la cuenta: RUBÉN ALFREDO JUNGBLUTH ADRIANZÉN
          <br>
          - DNI: 07797792
          <br>
          - Teléfono: +51 1 654 3715
          <br>
          - Ubicación: Malecón Balta 1070, Miraflores, Lima, Perú
          <br>
          <br>
        </dd> -->

        <dt v-if="transfer">Voucher de pago</dt>
        <dl v-if="transfer">
          <v-file-input
            class="mt-3 input-folder d-inline-block"
            placeholder="Adjunta tu voucher de pago"
            outlined
            dense
            type="file"
            show-size="true"
            prepend-icon=""
            hint="El archivo debe pesar menos de 10mb."
            persistent-hint="true"
            color="primary"
            id="file"
            ref="file"
            v-model="file"
          ></v-file-input>
          <label for="file" style="cursor: pointer; margin-left: 12px"
            ><v-icon>mdi-file-plus-outline</v-icon></label
          >
        </dl>
        <dl v-if="transfer === false && paypalPay === false" class="text-center">
          <v-btn
            outlined
            color="primary"
            @click="
              payConsultation = false;
              queryData = false;
            "
            class="mr-4"
            >Cancelar</v-btn
          >
          <v-btn
            color="primary"
            class="white--text"
            id="buyButton"
            @click="suscribeCulqi(), buyButton()"
            >Pagar
          </v-btn>
        </dl>
        <dl v-if="transfer && paypalPay === false" class="text-center">
          <v-btn
            outlined
            color="primary"
            @click="
              payConsultation = false;
              queryData = false;
            "
            class="mr-4"
            >Cancelar</v-btn
          >
          <v-btn color="primary" class="white--text" @click="payTransfer">Pagar </v-btn>
        </dl>
        <dl v-show="transfer === false && paypalPay" class="text-center">
          <v-btn
            outlined
            color="primary"
            @click="
              payConsultation = false;
              queryData = false;
            "
            class="mr-4"
            >Cancelar</v-btn
          >
          <template v-show="!queryData">
            <div
              class="v-btn"
              style="background: none; display: inline-block; padding: 10px 0px"
              ref="paypal"
            ></div>
          </template>
        </dl>

        <v-dialog v-model="dialog2" max-width="512" persistent v-if="transfer">
          <v-card rounded class="dialog-appointment pa-3">
            <v-icon @click="goToDetails" style="position: absolute" class="close-btn"
              >mdi-close</v-icon
            >
            <div class="ctn-img text-center mt-10">
              <img src="../assets/logo.png" />
            </div>
            <v-card-text class="text-center">
              <p class="text-center modal-text">
                ¡Muchas gracias! <br />
                Pronto te notificaremos la transferencia o depósito de tu pago.
              </p>
              <v-btn color="primary" class="btn-continue" @click="goToDetails"
                >Continuar</v-btn
              >
            </v-card-text>
          </v-card>
        </v-dialog>
      </form>
    </v-card>

    <v-card>
      <template>
        <div class="text-center">
          <v-snackbar timeout="9000" v-model="snackbar" :multi-line="multiLine">
            {{ text }}
          </v-snackbar>
        </div>
      </template>
    </v-card>

    <div v-if="queryData">
      <v-card color="#ECEFF1" class="bill">
        <dt class="title mb-4 ma-4">
          <h3 style="font-family: Avenir">Datos de su consulta</h3>
        </dt>
        <dl class="text-body-1 bill-text">
          <dl>
            <dd class="ma-4">Fecha: {{ arrayPost.date }}</dd>
            <dd class="ma-4">Motivo: {{ arrayPost.reason }}</dd>
            <dd class="ma-4">Monto: US$ {{ arrayPost.price }}</dd>
            <dd class="ma-4">Medio de pago: {{ textMethodPayment }}</dd>
            <dd class="ma-4">Estado: {{ textStateDetail }}</dd>
          </dl>
        </dl>
      </v-card>

      <strong
        ><p class="mt-7">
          Si tienes alguna duda o comentario comunicate con nosotros a
          <a href="mailto:contacto@rubenjungbluth.com">contacto@rubenjungbluth.com</a>
        </p></strong
      >

      <v-btn class="mr-5" outlined color="primary" @click="downloadPDF" large
        >Imprimir</v-btn
      >
      <v-btn class="mr-5 backto" @click="backTo" color="primary" large
        >Regresar a consulta personal</v-btn
      >
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
import jsPDF from "jspdf";
import router from "@/router";

export default {
  name: "Appointments",
  data() {
    return {
      headers: [
        {
          text: "Última cita",
          value: "date",
          align: "start",
          sortable: false,
        },
        {
          text: "Motivo",
          value: "description",
          sortable: false,
        },
        {
          text: "Estado",
          value: "state",
          sortable: false,
        },
      ],
      underline: false,
      payConsultation: false,
      dialog: false,
      dialog2: false,
      mode: false,
      radiosMode: "2",
      transfer: false,
      radiosTransfer: "2",
      money: 0,
      arrayPost: [],
      culqiPublicKey: "",
      culqi: [],
      token: "",
      email: "",
      data: {},
      idConsultation: 0,
      partial: undefined,
      price: undefined,
      queryData: false,

      multiLine: true,
      snackbar: false,
      text: "Ocurrió un error inesperado. Por favor, inténtelo nuevamente",
      file: null,
      loader: false,

      paymentsTable: false,
      totalToPay: 0,
      needToPay: 0,
      statusPayment: [],
      confirmationPayment: false,
      textConfirmation: "La confirmación de algunos pagos aún está pendiente",
      textMethodPayment: "",
      textStateDetail: "",
      payTotal: "",
      datePayment: "",
      buttonNewConsult: false,
      changeTitle: false,

      paypalPay: false,
      loaded: false,
      product: {
        price: undefined,
        description: undefined,
      },
      paypalDescription: [],
      dialogConfirmed: false,
      consultConfirmed: false,
    };
  },
  computed: {
    ...mapState("appoinments", ["post", "postPayments"]),
    ...mapState("user", ["info"]),
  },
  methods: {
    ...mapActions("appoinments", ["fetchConsul", "fetchPayments", "addUserPayment"]),
    ...mapActions("user", ["fetchInfo"]),
    redirectNewConsult() {
      router.push("NewConsult");
    },
    async fetchConsultData() {
      this.loader = true;

      await this.fetchConsul().finally(() => {
        this.loader = false;
      });
      console.log(this.post);

      if (this.post.length) {
        for (let i in this.post) {
          if (this.post[i].state.description === "Pendiente de pago") {
            this.buttonNewConsult = true;
          } else {
            this.buttonNewConsult = false;
          }
        }
      }
    },
    async pushPayConsultation(id) {
      this.loader = true;
      this.idConsultation = id;
      this.arrayPost = this.post.find((x) => x.id === id);

      let request = {
        id: this.idConsultation,
      };

      await this.fetchPayments(request).finally(() => {
        this.payConsultation = true;
        this.loader = false;
        if (this.postPayments.length > 2) {
          this.changeTitle = true;
        }
      });

      if (this.postPayments.length > 0) {
        this.paymentsTable = true;

        for (let i = 0; i < this.postPayments.length; i++) {
          this.statusPayment.push(this.postPayments[i].confirmed);
        }

        if (this.statusPayment.includes(0) === true) {
          this.confirmationPayment = true;
        } else {
          this.confirmationPayment = false;
        }

        this.postPayments.forEach((element) => {
          if (element["rejected"] !== 1) {
            this.totalToPay += element["amount"];
          }
        });
        this.needToPay = this.arrayPost.price - this.totalToPay;
      } else {
        this.paymentsTable = false;
        this.needToPay = this.arrayPost.price;
      }
    },
    otherMedium() {
      if (this.radiosTransfer === "1") {
        this.transfer = true;
        this.paypalPay = false;
        this.textMethodPayment = "Transferencia o Depósito";
      } else if (this.radiosTransfer === "2") {
        this.transfer = false;
        this.paypalPay = false;
        this.textMethodPayment = "Tarjeta de crédito/débito";
      } else if (this.radiosTransfer === "3") {
        this.paypalPay = true;
        this.transfer = false;
        this.textMethodPayment = "Paypal";
        const script = document.createElement("script");
        script.src =
          "https://www.paypal.com/sdk/js?client-id=AfFurMVjm998lj3zFxB6YJ7LnyT1lknqcAFBWVcSg9-sfM2Z_tYttRqqzOrYkdpT5y1B6OuDZJHzaNFM&locale=es_ES";
        script.addEventListener("load", this.setLoaded);
        document.body.appendChild(script);
        console.log("paypalasdasdasd");
      }
    },
    otherMode() {
      if (this.radiosMode === "2") {
        this.mode = false;
      } else {
        this.mode = true;
      }
    },
    importSrc() {
      let culqiSrc = document.createElement("script");
      culqiSrc.setAttribute("src", "https://checkout.culqi.com/js/v3");
      document.head.appendChild(culqiSrc);
      let jquery = document.createElement("script");
      jquery.setAttribute("src", "https://code.jquery.com/jquery-3.5.1.min.js");
      document.head.appendChild(jquery);
    },
    suscribeCulqi() {
      this.culqi = window.Culqi;
      this.culqi.publicKey = "pk_live_YrQ2nbQBuzOf14gh";
      this.culqiPublicKey = this.culqi.publicKey;

      if (this.radiosMode === "1") {
        this.price = this.partial;
        this.payTotal = "Pago parcial";
      } else if (this.radiosMode === "2") {
        this.price = this.needToPay;
        this.payTotal = "Pago total";
      }

      if (this.price < 10 || (this.price > this.needToPay - 10 && this.radiosMode != 2)) {
        this.text = "Precio ingresado es incorrecto. Por favor, inténtelo nuevamente";
        this.snackbar = true;
      } else {
        if (this.price % 1 === 0) {
          this.culqi = window.Culqi;
          this.culqi.publicKey = "pk_live_YrQ2nbQBuzOf14gh";
          this.culqiPublicKey = this.culqi.publicKey;

          this.culqi.settings({
            title: "Ruben Jungbluth",
            currency: "USD",
            description: "Consulta personal",
            amount: `${this.price}00`,
          });
        } else {
          this.text = "Precio ingresado es incorrecto. Por favor, inténtelo nuevamente";
          this.snackbar = true;
        }
      }
    },
    buyButton() {
      if (this.radiosMode === "2") {
        this.culqi.open();
        this.payTotal = "Pago total";
      } else if (this.radiosMode === "1") {
        this.price = this.partial;
        if (this.price < 10 || this.price > this.needToPay) {
          this.text = "Precio ingresado es incorrecto. Por favor, inténtelo nuevamente";
          this.snackbar = true;
        } else {
          this.payTotal = "Pago parcial";
          this.culqi.open();
        }
      }
    },
    backTo() {
      location.reload();
    },
    async payTransfer() {
      if (this.radiosMode === "1") {
        this.price = this.partial;
        this.payTotal = "Pago parcial";
      } else if (this.radiosMode === "2") {
        this.payTotal = "Pago total";
        this.price = this.needToPay;
      }

      if (this.price < 10 || (this.price > this.needToPay - 10 && this.radiosMode != 2)) {
        this.text = "Precio ingresado es incorrecto. Por favor, inténtelo nuevamente";
        this.snackbar = true;
      } else {
        if (this.price % 1 === 0) {
          this.data = new FormData();

          this.data.append("file", this.file);
          this.data.append("payment_method_id", this.radiosTransfer);
          this.data.append("payment_type_id", this.radiosMode);
          this.data.append("amount", this.price);

          this.loader = true;

          await axios
            .post(
              `personal-consultation/${this.idConsultation}/pay/transfer`,
              this.data,
              { headers: { "Content-Type": "multipart/form-data" } }
            )
            .then((response) => {
              this.datePayment = response.data.consultation_payment.created_at.slice(
                0,
                10
              );
              if (response.data.consultation_payment.confirmed === false) {
                this.textStateDetail = "Pendiente de confirmación";
              } else {
                this.textStateDetail = "Confirmado";
              }
              this.dialog2 = true;
            })
            .catch((error) => {
              console.log(error.response);
              this.snackbar = true;
            });
        } else {
          this.text = "Precio ingresado es incorrecto. Por favor, inténtelo nuevamente";
          this.snackbar = true;
        }
        this.loader = false;
      }
    },

    setLoaded() {
      this.loaded = true;
      window.paypal
        .Buttons({
          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  description: this.arrayPost.reason,
                  amount: {
                    currency_code: "USD",
                    value: this.arrayPost.price,
                  },
                },
              ],
            });
          },
          onApprove: async (data, actions) => {
            const order = await actions.order.capture();
            this.data;
            this.queryData = true;
            console.log(order);
            this.paypalDescription = order;

            this.data = new FormData();

            this.data.append("payment_method_id", 2);
            this.data.append("payment_type_id", this.radiosMode);
            this.data.append("amount", this.arrayPost.price);
            this.data.append("description", "Pago consulta");
            this.data.append("outcomeResponse", JSON.stringify(order));
            this.data.append("paymentProvider", "PAYPAL");

            await axios
              .post(
                `personal-consultation/${this.idConsultation}/pay/online`,
                this.data,
                { headers: { "Content-Type": "multipart/form-data" } }
              )
              .then((response) => {
                console.log(response);
                this.fetchInfo().finally(() => {
                  const arrayName = this.info.user_data.display_name.split(" ");
                  const dataPostContact = {
                    Data: {
                      Email: this.info.user.email,
                      FirstName: arrayName[0],
                      LastName: arrayName[1],
                      EmailPerm: "1",
                    },
                  };

                  axios.post(
                    `https://clientapi.benchmarkemail.com/Contact/16603151/ContactDetails`,
                    dataPostContact,
                    {
                      headers: {
                        "Content-Type": "application/json",
                        AuthToken: "8A6D78E4-CB1B-4185-A003-CD38D170CE87",
                      },
                    }
                  );
                });
                this.textStateDetail = "Confirmado";
              })
              .catch((error) => {
                console.log(error.response);
              });
          },
          onError: (err) => {
            console.log(err);
          },
          style: {
            layout: "horizontal",
          },
        })
        .render(this.$refs.paypal);
    },
    goToDetails() {
      if (this.radiosTransfer === "2") {
        this.textMethodPayment = "Transferencia o Depósito";
      }
      this.queryData = true;
    },
    downloadPDF() {
      let pdf = new jsPDF();
      pdf.setTextColor(101, 101, 101);
      pdf.text("Hola", 20, 30);
      pdf.setFontSize(12);
      pdf.text(
        `Te informamos que hemos recibido el ${this.payTotal} de tu consulta. ¡Muchas gracias!`,
        20,
        40
      );
      pdf.setFontSize(12);
      pdf.text(`Ve aquí los detalles de tu pago: `, 20, 50);
      pdf.setFontSize(12);
      pdf.text(`Método de pago: ${this.textMethodPayment}`, 30, 70);
      pdf.text(`${this.datePayment}`, 156, 70);
      pdf.setLineWidth(1);
      pdf.setDrawColor(67, 164, 187);
      pdf.line(30, 75, 179, 75);
      pdf.setFontSize(12);
      pdf.text(`Precio:`, 30, 85);
      pdf.text(`US$ ${this.arrayPost.price}`, 160, 85);
      pdf.setFontSize(12);
      pdf.text(`Monto pagado:`, 30, 95);
      pdf.text(`US$ ${this.price}`, 160, 95);
      pdf.setFontSize(12);
      pdf.text(`Monto pendiente de pago:`, 30, 105);
      pdf.text(`US$ ${this.needToPay - this.price}`, 160, 105);
      pdf.setFontSize(12);
      pdf.text(`Bendiciones del Cielo, `, 20, 125);
      let imgWhite =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIgAAAA5CAYAAADtLGOCAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAiKADAAQAAAABAAAAOQAAAACQgQO2AAAIkElEQVR4Ae2aT3LbNhTGrU735Q1CnyDMTLedINNtZ6qcwMwJopwg9Ami7rozc4KqM92bPkGYE4TedVfmBO7vU0kHokEKlGiJrvhmvgB8f4CHD48QSefsbJLBGLi7u4tA7BoQ/QLMXbYx674fc3JPLbfZbJZTBEEzb3QRugKUTdt0fWIMqBjsIqFvQHhiNEzL7WKgLpCqOB6cKF2xY7PNxpbQU8unOh3ekvdv4Bn4DL6AArwCz4EtX7mYg5yfpJVtGGN/egYZZldu2eyCoYrq9NCpcY6upL0BG4JPhEK2SU6RARVJVSinuPxpzafEwNGfQbjTDIS/dJD+J0d07tBPqgMy8N0B52qbymB4A1SsNlYUzzXQ7/Ukp8oABZCAzLV+9EvwDwhc9lqHvXWM2sdu8b+zr+0+plx2SzT/NfgAQtvX7mNTDm2SNHwNjn/Yuq4+vr3W1zVWX9sYTpDWnPmJWWC8BWoPJXotfcXca6F/Di6BTjcVT9eJdlmFNZuE2KbMGeuqqRzb9agLpCJrRWuORRw7XYIMqEiVSzxQLvpe8oIiGWq8gdLaHGb6DrLJx7arAgezzcnTXuKnossokjMKMPWMO6jbUzhBDIxkB2Wle7LBcqEocqaaAz1rRd3THsc66gKBNAMtegVOwVGFXAIS0Cf1bMhE9PPFeAugk2R0RTLan5iKrA8Q9wYSC9pDygXz299mQiafg8tqQ9tyeUnc+6aRGD3ktgr2lLgQhyvaV1yXrc4HNoylQJ5BjE2syNKGvBN5tIcWvbEItdzS0R/ZnpNn0LGB8rupg/q0jKlX2ZCYa/CiT+xj+o6lQES+iNURGwARPQO+d5KvH0N6ScqGZQ1PbeAK3RLEDVt9WTjiatvWltiYOTJwRf/N1oADOIylQNavkqw3q9cMSTn9lDaCrKLWt7TynbfYNtSMZzYU/S5UHLrD435hvby1DhXJknUvekU+gvNoH1IhZ8V6BZ8vjiV+L3vwo28QvYWcst5BPQOYQ2sxQKdJTHtUGW2BVKwsaGe6m7pYgtQc+63n6RDju+oar83G+GGbbUi9VSR6/TVDjt13rFEXSEVUzKJ87iYV0RWEBm0kVGTPsadtPlv0Bruejx5dqqKPmUjFHIKjyKgLRIxURGlTtfmxdC7Bb4n+BnzC71fbh+sA6C1Jzw8LfAvb7tMnXjnotVvzHETIc8VEC3BxkAkdk4zlIdWR2jcVROmhTa9+K1pt/iW6/JvHfz109UlziZ/ILUAAZiADL1xx6G3RG5X+cltWSsVHQCfHttfuC+Jcz0KfmXdRjderIS5lTM0vHFxEXKuQWIDxE8hJ9HWr4x4G5ggJDzw2bj0L/iJa/slaMfA/VT6hNWzpk5sjzhribGMMfMVr6DNuPQgxUR//Ou5RWy0aSIpHnWga/OkyQHGoSFTxk5wgAz4PqQZewhPkZloyDPgUiIpjOkFOtFx8CuREqZmWLQamApnqoJOBqUA66ZmMO38o09sN9BnezVMfGvFP8EvxL2x/9DHX+k6wsvVtffyNbPhnal2Cj56Z9PXRAPv5qeA6BzfEq30gVT7PHhj++xb0p0O/VhH3E50fGPevNp9aj29If2fuOnKsp7BbrTWrFcQm9B/sQ22vW/yM+vucICHxMfCV9ziGDmfprkgocthcKoNScArjxBi+AH15/QjegcsK2uBzsARtEmOQz6wBfZ39AkL0LlGB/OIyOHQhutihb1M1uVsXOc43Fl7T/2pd17YCnS3NsWyb3TdcmJ1PEHukAfrajAzy9bWw2HU84mNitfm6O0WiS1YuZUOnOyxr6BLGV2wCYnA0ca2N3EoSyh1575XnPifIXhM3grWZS/AHCw0aNq9L4iIcr0BXcXiN1eG0whZ22P93prEUyBmVn8DuZ3C9I8uKv3TdXTuO5worXcr/s240BSKS2dxYDaeBTgJvqU4d/ZU39Q7azXFOWL5b6NOMGssziM2e4ULPI0l1qti2tn6E4Rb/os2hp17/e/2uERNzrQIJwcnI6AqETS7Zm/WdSltwnXrsRohP4eHn6/IGx9JyVgH+ABbKz9I/1e71w/p3LuVydAWiNHUSsABDVyeJiiSj3yW9No0xEwYzjGtaBlUhZLaNmJBr/Yelc2wL2/YE+6+a62uuoeLobN9nEN1VfaTwdWYBOb4x0KZEW+JUIM+3+OxlJp+CAebg7V4DfQvuy534OLjsUyDalMgnYzY4kF9Fsk/I2gf/FZ0F0EmyHsMVjF+GXg+3xmUfSlfnP9A8kU9ezBXKj7lLH/+hfXYuEBLOSeZrvYAtiRnseoXtLcyTErQC18wVdAywxPa+wz4aE2vKlIwndxGuO3GnOfaVnQukmlgbl3gkscBHvjsJhMYEiqSu198l9nNIT2gfRawCLQaY4CNjJB7jiLvUw+9RXHwLJGiZPUE/h7h5i113iRYYgmWbj6de45wD5zMARVRim4MFc+p/pQf0h5YlA94wVzHAwAljbONOPiFIwVHE5y0mIrPMlZ2IYiMMNj1IXtDmIAMSU0GbOq82kO5uovhqrqxtBHxyfELsK/CJvlqhlpBOBObgBrTJBbEvLWNAXzG3YGHpm90fiUuaSq7/JrffbT3XNXcZMdfYMpBXPoZW883Uau20RxEl0CkkX+BgtKA2R3wCbFqQASGQFCAjLqVtFWINxnCbXz0A/hH9AP+s1rnayq/OqXYp6ORAeal9IMQpJmoYSq5bY+RL3E80P6vvkAcFUvsQF9DXnAaEQFKArdzJsRbGiekrpqh1rha/BH3q4Wdc8Rs6BjMg31BOFxMDNQMqDhVJfT21EwP3DFAYqXCvmDoTAzUDVXHo9NDv4yQnzMDGay4FoWeOL+KDh5gIlCfMzbR0MUBBzMFbEIECmImZiYF7BiiIEkjCe+XUmRioGNCHsgXQz0lR6aZmYuCegX8Bm6KqahYXlcYAAAAASUVORK5CYII=";
      let imgBlue =
        "data:image/png;base64,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";
      pdf.setFillColor(41, 103, 139);
      pdf.rect(0, 0, 400, 20, "F");

      pdf.addImage(imgWhite, "png", 21, 2, 35, 13);
      pdf.addImage(imgBlue, "png", 21, 134, 50, 20);

      pdf.save("comprobante.pdf");
    },
  },
  mounted() {
    this.fetchConsultData();
    this.importSrc();
    window.culqi = async () => {
      if (this.culqi.token) {
        var token = this.culqi.token.id;
        window.cul = this.culqi;
        this.data = {
          token: token,
          amount: this.price,
          payment_type_id: this.radiosMode,
          payment_method_id: this.radiosTransfer,
          description: this.arrayPost.reason,
        };
        this.loader = true;
        axios
          .post(`personal-consultation/${this.idConsultation}/pay/online`, this.data)
          .then((response) => {
            console.log(response.data);
            console.log(response.status);
            console.log(response.statusText);
            console.log(response.headers);
            console.log(response.config);
            if (response.status == 200) {
              this.fetchInfo().finally(() => {
                const arrayName = this.info.user_data.display_name.split(" ");
                const dataPostContact = {
                  Data: {
                    Email: this.info.user.email,
                    FirstName: arrayName[0],
                    LastName: arrayName[1],
                    EmailPerm: "1",
                  },
                };

                axios.post(
                  `https://clientapi.benchmarkemail.com/Contact/16603151/ContactDetails`,
                  dataPostContact,
                  {
                    headers: {
                      "Content-Type": "application/json",
                      AuthToken: "8A6D78E4-CB1B-4185-A003-CD38D170CE87",
                    },
                  }
                );
              });
              this.datePayment = response.data.consultation_payment.created_at.slice(
                0,
                10
              );
              if (this.radiosTransfer === "2") {
                this.textMethodPayment = "Tarjeta de crédito/débito";
              }
              if (response.data.consultation_payment.confirmed === true) {
                this.textStateDetail = "Confirmado";
              } else {
                this.textStateDetail = "Pendiente de confirmación";
              }
            }
            this.queryData = true;
            this.loader = false;
          })
          .catch((error) => {
            console.log(error);
            console.log(error.response);
            this.text = error.response.data.provider_response.user_message;
            this.snackbar = true;
            this.queryData = false;
            this.loader = false;
          });
      }
    };
    if (this.$route.params.openAlert) {
      this.dialogConfirmed = true;
      this.consultConfirmed = true;
    }
  },
};
</script>
<style lang="scss" scoped>
$breakpoints: (
  "tablet": 768px,
);
@mixin mobile {
  @media screen and (max-width: map-get($breakpoints, tablet)) {
    @content;
  }
}
#modal-es {
  display: grid;
  padding: 4px;
  text-align: center;
}
#modal-en {
  border-radius: 5px;
  color: #656565;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
  padding: 6px 50px;
  font-size: 14px;
}
#modal-en:hover {
  opacity: 0.8;
}

.v-input.input-folder {
  width: 300px;
}

.table-ctn {
  padding: 20px;

  .highlight {
    color: #29678b;
    font-weight: 600;
  }

  ::v-deep thead {
    font-size: 16px;

    th {
      border-bottom: 2px solid #43a4bb !important;
      font-size: 16px !important;
      font-weight: 800;

      &:nth-child(1) {
        width: 25%;
      }

      &:nth-child(2) {
        width: 40%;
      }

      &:nth-child(3) {
        width: 36%;
      }
    }

    span {
      font-size: 16px;
      font-weight: 600;
      color: #656565;
    }
  }

  ::v-deep tbody {
    &:before {
      content: "";
      display: block;
      padding-top: 8px;
    }

    td {
      font-size: 16px;
      font-weight: 200;
      color: #656565;
      border-bottom: none !important;

      &:last-child {
        text-align: center;
      }
      @include mobile {
        padding: 10px 0 !important;
        text-align: center !important;
      }
    }
  }

  @include mobile {
    ::v-deep .v-btn {
      width: 100%;
    }
  }
}

::v-deep .v-btn {
  text-transform: unset;
  font-family: "Avenir";
  letter-spacing: normal;
  font-size: 14px;
  height: 40px;
  width: 160px;
  border-radius: 7px;
}

::v-deep .v-input {
  width: 250px;
  .v-messages__message {
    padding-top: 3px;
  }
  &.v-input--is-disabled {
    .v-input__slot::before {
      display: none;
    }

    .v-input__append-inner {
      display: none;
    }
  }

  .v-input__slot {
    margin-bottom: 0;

    .v-text-field__slot input {
      color: #656565;
    }
  }
}

.bill {
  padding: 10px 20px;

  .title {
    font-size: 18px;
  }

  .bill-text {
    font-size: 16px;
    font-weight: 200;
    margin-bottom: 5px;

    dd {
      padding-bottom: 8px;
    }
  }
}

.dialog-appointment {
  .close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    background: #cbcbcb;
    border-radius: 50% !important;
    color: #fff;
    font-size: 15px;
    width: 30px;
    height: 30px;
  }

  .modal-text {
    margin-top: 20px;
    font-size: 18px;
    font-weight: 600;
  }

  ::v-deep .btn-continue {
    display: block;
    margin: 10px auto 10px;
  }

  .ctn-img {
    margin-top: 40px;

    img {
      width: 75px;
    }
  }
}

.backto {
  width: 200px;
}

dt,
dl {
  color: #656565;
}

dt {
  font-size: 16px;
  font-weight: 800;
  margin-bottom: 2px;
}

dl {
  font-size: 16px;
  font-weight: 200;
  margin-bottom: 15px;
}

.ctn-new-query {
  padding: 35px 30px;
  @include mobile {
    ::v-deep .v-btn {
      margin-bottom: 10px;
      margin-left: 0;
      margin-right: 14px;
    }
  }
}

.last-payments {
  width: 95%;
  margin: 0 auto;

  th {
    font-weight: 800;
    font-size: 14px;
    border-bottom: 1px solid #43a4bb !important;
  }

  td,
  th {
    &:last-child {
      text-align: center !important;
    }
  }
}

.primary-text {
  color: #43a4bb;
}

.w100 {
  width: 100%;
}

.radio-group {
  ::v-deep .v-input--radio-group__input {
    display: inline-block;
  }
}

.radio-ctn {
  width: 50%;
  display: inline-block;

  ::v-deep label {
    line-height: 25px !important;
    vertical-align: top;
  }
  @include mobile {
    width: 100%;
  }
}

.new-consult-title-line {
  position: relative;

  h2 {
    font-family: "Virgula Vulgaris";
    width: auto;
    display: inline-block;
    padding: 0 8px 0 0;
    background: #ffffff;
    z-index: 2;
    position: relative;
  }

  hr {
    position: absolute;
    top: 21px;
    width: 100%;
    z-index: 0;
    border-color: #656565;
    opacity: 0.1;
  }
}
.description-transfer {
  font-size: 14px;
  color: #656565;
}
/*.input-file-in {*/
/*width: 300px;*/
/*}*/
</style>
